// Gestión de operadores del negocio (módulo core users_admin, backend /api/biz/users).
// Port del usersService de la agenda dental (2026-07-01) — mismo contrato cross.
import { api } from '../../services/apiClient';

export type UserRole = 'owner' | 'manager' | 'staff';

export interface Operator {
  id: number;
  role: UserRole;
  name: string;
  email: string | null;
  phone: string | null;
  is_active: number;
  created_at: string;
  branch_ids: number[];
  has_password: number; // 1 = ya activó (tiene contraseña); 0 = invitación pendiente
  // Puesto detectado (solo si el negocio tiene perfiles): clave del perfil · 'full' = gerente sin
  // ajustes (ve todo, dinero incluido) · 'custom' = gerente ajustado a mano · null = no aplica.
  profile?: string | null;
}

// ── Puestos (perfiles fijos del negocio: rol + permisos; los aplica el servidor al invitar) ──
export interface StaffProfile { key: string; label: string; role: UserRole; summary: string }
export const listProfiles = (): Promise<{ profiles: StaffProfile[] }> => api.get('/biz/users/profiles');
export const applyProfile = (id: number, profile: string): Promise<{ ok: true }> =>
  api.put(`/biz/users/${id}/profile`, { profile });

export const listOperators = (): Promise<{ users: Operator[] }> => api.get('/biz/users');

// Alta por invitación: manda correo brandeado para que la persona fije su contraseña.
export const inviteOperator = (p: { name: string; email: string; role: UserRole; profile?: string }): Promise<{ id: number; invited: boolean }> =>
  api.post('/biz/users', { ...p, invite: true });

export const patchOperator = (id: number, patch: Partial<Pick<Operator, 'name' | 'is_active' | 'role' | 'phone'>>): Promise<{ ok: true }> =>
  api.patch(`/biz/users/${id}`, patch);

export const resendInvite = (id: number): Promise<{ ok: true }> => api.post(`/biz/users/${id}/send-invite`, {});
export const sendReset = (id: number): Promise<{ ok: true }> => api.post(`/biz/users/${id}/send-reset`, {});

// ── Permisos por usuario (user_module_override; solo owner = nivel manage) ──
export type PermLevel = 'none' | 'view' | 'operate' | 'manage';

export interface ModulePermission {
  key: string;
  name: string;
  kind: 'core' | 'cross' | 'vertical';
  inherited: PermLevel;          // lo que le da su rol
  override: PermLevel | null;    // ajuste personal (null = hereda)
  effective: PermLevel;
}

export const getPermissions = (id: number): Promise<{ user: { id: number; name: string; role: UserRole }; modules: ModulePermission[] }> =>
  api.get(`/biz/users/${id}/permissions`);

export const savePermissions = (id: number, overrides: Record<string, PermLevel | null>): Promise<{ ok: true }> =>
  api.put(`/biz/users/${id}/permissions`, { overrides });

// ── "Ver como" (impersonación; solo owner, nunca sobre otro owner) ──
// El backend cambia la cookie de sesión → tras el ok hay que recargar la app completa.
export const impersonate = (id: number): Promise<{ ok: true; viewing: { id: number; name: string; role: UserRole } }> =>
  api.post(`/biz/users/${id}/impersonate`, {});

export const stopImpersonation = (): Promise<{ ok: true; restored: boolean }> =>
  api.post('/auth/stop-impersonation', {});
